const HTTP_STATUS_OK_MIN = 200;
const HTTP_STATUS_OK_MAX = 299;

const isStatusOK = (status: number): boolean =>
    status >= HTTP_STATUS_OK_MIN && status <= HTTP_STATUS_OK_MAX; /* >=200 && <=299 */

export default Object.freeze({
    isStatusOK,
});
